





























































































import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import DocumentMixin from '@/mixins/DocumentMixin';
import EventMixin from '@/mixins/EventMixin';
import { IDRec, TableOptions } from '@/interfaces';
import FileUpload from '@/components/FileUpload.vue';
import { Dictionary } from 'vue-router/types/router';
import DocPreviewDialog from '@/components/DocPreviewDialog.vue';

@Component({
  components: {
    FileUpload,
    DocPreviewDialog
  }
})
export default class DocumentTable extends Mixins(DocumentMixin, EventMixin) {
  // Props
  @Prop() public rec!: IDRec;
  @Prop(String) public fileUrl!: string;
  @Prop(String) public parameter!: string;

  public tableTotal: number = 0;
  public filesLoading = false;
  public files: any[] = [];

  public fileTableFields = [
    {
      text: 'Type',
      value: 'orderdoctype_name',
      width: '10%',
      filter: 'document-type'
    },
    {
      text: 'Nummer',
      value: 'docnr',
      width: '15%'
    },
    {
      text: 'Bedrag (excl.)',
      value: 'amount_exclusive',
      width: '15%',
      filter: 'euro'
    },
    {
      text: 'Bedrag (incl.)',
      value: 'amount_inclusive',
      width: '15%',
      filter: 'euro'
    },
    {
      text: 'Datum',
      value: 'creationdate',
      width: '15%',
      filter: 'date'
    },
    {
      text: 'Bestand',
      value: 'file.name',
      width: '15%',
      align: 'center',
      sortable: false
    },
    {
      text: 'Status',
      value: 'state',
      width: '15%',
      align: 'center',
      sortable: false
    }
  ];
  public tableFooterProps = {
    'items-per-page-options': [10, 15, 20],
    'show-current-page': true,
    'show-first-last-page': true
  };
  public tableOptions: TableOptions = {
    page: 1,
    itemsPerPage: 10,
    sortBy: ['creationdate'],
    sortDesc: [true],
    multiSort: true,
    mustSort: false
  };

  public get fileTableHeaders() {
    const headers: object[] = [];
    for (const field of this.fileTableFields) {
      const header = {
        text: field.text,
        value: field.value,
        width: field.width || '',
        align: field.align || 'start',
        sortable: field.sortable !== undefined ? field.sortable : true
      };
      headers.push(header);
    }
    return headers;
  }

  public generateSlotName(header): string {
    return `item.${header}`;
  }

  // Support nested values
  public getItemValue(item, value) {
    const subelements = value.split('.');
    let itemValue = item;
    for (const subelement of subelements) {
      if (!itemValue) {
        return null;
      }
      itemValue = itemValue[subelement];
    }
    return itemValue;
  }

  public getSortString() {
    let sort: string = '';
    const sortBy: string[] = this.tableOptions.sortBy;
    const sortDesc: boolean[] = this.tableOptions.sortDesc;
    for (let i = 0; i < sortBy.length; i++) {
      if (!sort) {
        // First sort parameter
        sort = sortBy[i] + (sortDesc[i] ? '|D' : '');
      } else {
        sort += ',' + sortBy[i] + (sortDesc[i] ? '|D' : '');
      }
    }
    return sort;
  }

  public async getFiles(id) {
    const params: Dictionary<number | string> = {
      page: this.tableOptions.page,
      per_page: this.tableOptions.itemsPerPage
    };
    params.sort = this.getSortString();
    params[this.parameter] = String(id);
    const fileResponse: any = await this.api.getRecord(
      undefined,
      this.fileUrl,
      params
    );
    if (fileResponse) {
      this.files = fileResponse.data.data;
      this.tableTotal = fileResponse.data.pagination.total;
      this.filesLoading = false;
    }
  }

  public downloadItem(endpoint, id) {
    this.api.downloadFile(this.$store, this.fileUrl + id + '/' + endpoint);
  }

  public previewItem(endpoint, id) {
    const ref: any = this.$refs.docpreview;
    ref.open(this.fileUrl + id + '/' + endpoint);
  }

  public mounted() {
    this.filesLoading = true;
    this.getFiles(this.$route.params.id);
  }

  @Watch('tableOptions')
  public onPropertyChanged(value: string, oldValue: string) {
    this.getFiles(this.$route.params.id);
  }
}
